module.exports = __webpack_public_path__ + "static/media/started-pattern-two.e059046d.png";